import React, { useState, useRef } from "react";
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Spinner, Input } from "@nextui-org/react";
import ReactToPrint from 'react-to-print';

export default function PrintOkayModal({ data , allpay, too}) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const componentRef = useRef(null);

  return (
    <>
      <Button onPress={onOpen}>Хэвлэх</Button>
      <Modal isOpen={isOpen} onClose={onClose} scrollBehavior='inside' size="md">
        <ModalContent>
          <ModalBody>
            <div
              ref={componentRef}
              className='border-2 font-Roboto p-5'
              style={{
                width: '80mm',
                height: '120mm',
              }}
            >
              
              <h1 className="text-sm">Хэрэглэгчийн утасны дугаар:</h1>
              <p className="font-bold">{data.user.phone_no}</p>
              <h1 className="text-sm mt-2">Нэмэлт утасны дугаар:</h1>
              <p className="font-bold">{data.phone_additional}</p>

              <h1 className="text-sm mt-2">Албан хаяг</h1>
              <p className="font-bold">{data.address.city}, {data.address.district}, {data.address.khoroo}</p>

              <h1 className="text-sm mt-2">Дэлгэрэнгүй хаяг</h1>
              <p className="font-bold">{data.address.address}</p>

              <h1 className="text-sm mt-2">Барааны тоо</h1>
              <p className="font-bold">{too}</p>

              <h1 className="text-sm mt-2">Карго төлбөр</h1>
              <p className="font-bold">{allpay}</p>

              <h1 className="text-center mt-4 font-bold">Мөрөөдөл каргог сонгодог таньд баярлалаа</h1>

            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" variant="light" onPress={onClose}>
              Болих
            </Button>
              <ReactToPrint
                trigger={() => (
                  <Button className=" bg-blue-600 text-white" >
                    Хэвлэх
                  </Button>
                )}
                content={() => componentRef.current}
                pageStyle={`
                  @page {
                    size: A7;
                    margin: 0;
                  }
                  @media print {
                    body {
                      width: 74mm;
                      height: 105mm;
                      margin: 0;
                    }
                  }
                `}
              />
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}